import { ScriptType } from "@/enums/campaigns";

/** Galactus v2 `type` discriminator / outbound path segment (except phone omits path segment). */
export type ScriptTypeWireSegment = "phone" | "text" | "email" | "blaster";

/**
 * Map UI ScriptType to the shared wire/path segment used by v2 APIs and outbound URLs.
 * Throws on unknown values so invalid casts cannot silently become "phone".
 */
export const scriptTypeToWireSegment = (scriptType: ScriptType): ScriptTypeWireSegment => {
  switch (scriptType) {
    case ScriptType.Phone:
      return "phone";
    case ScriptType.PhoneBlaster:
      return "blaster";
    case ScriptType.Email:
    case ScriptType.EmailBlaster:
      return "email";
    case ScriptType.Text:
    case ScriptType.TextBlaster:
      return "text";
    default: {
      const _exhaustive: never = scriptType;
      throw new Error(`Unknown script type: ${String(_exhaustive)}`);
    }
  }
};
